module.exports = __webpack_public_path__ + "img/banner1_8.e3c4e794.png";